const HARD_NAVIGATION_PATHS = [/^\/api(?:\/|$)/, /^\/auth\/signout(?:\/|$)/];
const FILE_DOWNLOAD_PATH = /\.(?:csv|docx?|gif|jpe?g|pdf|png|svg|webp|xlsx?|zip)$/i;

export function shouldHandleInternalNavigation(href: string, currentOrigin: string): boolean {
  const trimmed = href.trim();
  if (!trimmed) return false;
  // Fragment-only links belong to the current document. Resolving them against
  // the origin would turn them into root-route navigations and discard the
  // current client, programme query and native anchor focus behaviour.
  if (trimmed.startsWith('#')) return false;
  if (/^(?:mailto|tel|sms|blob|data|javascript):/i.test(trimmed)) return false;

  let url: URL;
  try {
    url = new URL(trimmed, currentOrigin);
  } catch {
    return false;
  }

  if (url.origin !== currentOrigin) return false;
  if (HARD_NAVIGATION_PATHS.some((pattern) => pattern.test(url.pathname))) return false;
  if (FILE_DOWNLOAD_PATH.test(url.pathname)) return false;

  return true;
}
